import React from 'react';

import { getThemeStyles, useThemeObserver } from '@atlaskit/tokens';

export const useUnsetGlobalTheme = (
	targetElement: HTMLDivElement | null,
	idsToUnset: string[] = ['light', 'dark', 'spacing'],
): void => {
	const { colorMode, dark, light, spacing, typography, UNSAFE_themeOptions } = useThemeObserver();

	React.useEffect(() => {
		if (targetElement) {
			getThemeStyles().then((themeStyles) => {
				themeStyles.forEach((themeStyle) => {
					if (idsToUnset.includes(themeStyle.id)) {
						const allCssVariables = themeStyle.css.match(/--[\w-]+/g); // output => ['--ds-text', '--ds-text-accent-lime']
						allCssVariables?.forEach((cssVariable) => {
							targetElement.style.setProperty(cssVariable, 'initial');
						});
					}
				});
			});
		}
	}, [targetElement, idsToUnset, colorMode, dark, light, spacing, typography, UNSAFE_themeOptions]);
};
